import { useState, useEffect } from 'react';
import { DAV_APIS } from '../adapters';

let placesData: any[] = [];

const usePlaces = (refresh?: number | null) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [places, setPlaces] = useState<any[]>([]);

  useEffect(() => {
    const fetchPlaces = async () => {
      if (!navigator.onLine) return;
      if (placesData.length > 0 && !refresh) {
        setPlaces(placesData);
        return;
      }
      setLoading(true);
      try {
        const res = await DAV_APIS.place.get.getAllPlaces();
        setPlaces(res.data.places);
        placesData = res.data.places;
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };

    fetchPlaces();
  }, [refresh]);

  return { loading, places };
};

export default usePlaces;
